import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    outcome: "Bites stopped within days",
    quote: "After one treatment the bites stopped within days and we stopped finding spots on the sheets. The preparation was clear and the follow-up sealed it. Our condo is finally back to normal.",
    context: "Condo owner — Kitsilano, Vancouver",
  },
  {
    outcome: "Multi-unit problem resolved",
    quote: "Bed bugs had moved between three of our suites. Meridian coordinated treatment across all three units at once and the problem never came back. Discreet, professional, and effective.",
    context: "Property manager — Burnaby",
  },
  {
    outcome: "Guestroom back online fast",
    quote: "A guest complaint could have cost us reviews. They treated the room fast and quietly — no disruption to the rest of the floor — and we were back to booking within days.",
    context: "Hotel — Downtown Vancouver",
  },
  {
    outcome: "Listing protected",
    quote: "As a host, speed is everything. They got in fast, the treatment worked the first time, and my Airbnb rating stayed intact. I'd call them again in a second.",
    context: "Short-term rental host — North Vancouver",
  },
  {
    outcome: "No return after follow-up",
    quote: "We'd been treating it ourselves for weeks with no luck. One proper treatment plus the follow-up visit and the bed bugs were gone for good. Worth every dollar.",
    context: "Homeowner — Surrey",
  },
  {
    outcome: "Discreet and effective",
    quote: "Nobody in the building ever knew. They came in unmarked, did the treatment, and left clear aftercare notes. Two weeks later — no signs of bed bugs at all.",
    context: "Apartment tenant — New Westminster",
  },
];

export default function Testimonials() {
  return (
    <section className="border-b border-border bg-background px-5 py-24 lg:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <SectionHeader align="center" kicker="Outcomes" title="THE PROBLEM GONE. THE CUSTOMER SATISFIED." subtitle="Real outcomes from verified treatments across Vancouver and the Lower Mainland — judged by whether the bed bugs were actually gone." />
        <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((t, i) => (
            <Reveal key={t.outcome} delay={(i % 3) * 0.05}>
              <figure className="flex h-full flex-col rounded-lg border border-border bg-muted/20 p-6 transition-colors hover:border-accent/40">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1">
                    {[0, 1, 2, 3, 4].map((s) => <Star key={s} className="h-4 w-4 fill-accent text-accent" />)}
                  </div>
                  <Quote className="h-7 w-7 text-muted-foreground/20" aria-hidden />
                </div>
                <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.18em] text-accent">{t.outcome}</p>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground">“{t.quote}”</blockquote>
                <figcaption className="mt-5 border-t border-border pt-4 text-xs font-medium text-muted-foreground">{t.context}</figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}